import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "../ui/button";
import { SITE, NAV } from "../../lib/site";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAFAF8]/80 border-b border-border"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2.5 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_mortgage-broker-au-1/artifacts/imsydkxs_Wordpress-2025-06-10_083320.png"
            alt="Empower Legacy Finance"
            className="h-10 w-10 object-contain"
          />
          <span className="font-display tracking-tight text-lg md:text-xl lg:text-2xl text-brand-eucalyptus">
            Empower Legacy Finance
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="text-sm text-brand-ink/80 hover:text-brand-terracotta transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={SITE.phoneTel}
            data-testid="header-call-button"
            className="hidden md:inline-flex"
          >
            <Button className="bg-brand-terracotta hover:bg-brand-terracottaDark text-brand-cream rounded-full px-5 h-11 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md">
              <Phone className="h-4 w-4 mr-2" strokeWidth={1.8} />
              {SITE.phone}
            </Button>
          </a>
          <a
            href={SITE.phoneTel}
            data-testid="header-call-button-mobile"
            className="md:hidden inline-flex"
          >
            <Button
              size="icon"
              className="bg-brand-terracotta hover:bg-brand-terracottaDark text-brand-cream rounded-full h-10 w-10"
            >
              <Phone className="h-4 w-4" />
            </Button>
          </a>
          <button
            onClick={() => setOpen((s) => !s)}
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-brand-ink"
            aria-label="Toggle navigation"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="md:hidden bg-[#FAFAF8] border-t border-border"
        >
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-base text-brand-ink/90"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
